$(function(){
	$('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
	$('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
	$(".menu > ul").before("<a href=\"#\" class=\"menu-mobile\"></a>");
	$(".menu > ul > li").hover(function(e) {
	    if ($(window).width() > 1023) {
			$(this).children("ul").stop(true, false).fadeToggle(150);
			$(this).children("ul").css('display','block');
	        e.preventDefault();
	    }
	});

	if ($(window).width() < 992) {
		$(document).find('.normal-sub').css('display','block');
	}

	$(".menu > ul > li").click(function() {
	    if ($(window).width() <= 992) {
	        $(this).children("ul").fadeToggle(150);
	    }
	});
	$(".menu-mobile").click(function(e) {
	    $(".menu > ul").toggleClass('show-on-mobile');
	    e.preventDefault();
	});
	$(window).resize(function() {
	    $(".menu > ul > li").children("ul").hide();
	    $(".menu > ul").removeClass('show-on-mobile');
	});
	
	$(document).on('scroll', function() {
		if ($(this).scrollTop() > $('.section-header').height()) {
			$('.header__menu').addClass('nav-scrolled');
			setTimeout(function(){ $('.header__menu').slideDown(); }, 200);
		} else {
			$('.header__menu').removeClass('nav-scrolled');
			$('.header__menu').attr('style', '');
		}
	});
});